import { Component, Injector, Input, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { WidgetDynamicBaseComponent } from '../../widgetDynamicBase';

@Component({
  selector: 'direct-cap-expense-comps-widget',
  templateUrl: './direct-cap-expense-comps-widget.component.html',
  styleUrls: ['./direct-cap-expense-comps-widget.component.scss', '../../common/css/general.scss']

})
export class DirectCapExpenseCompsWidgetComponent extends WidgetDynamicBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'directCapExpenseComps', true);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();

  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useDefaultServiceSaveChangesHandler('directCapExpenseComps', this.provideSaveObject.bind(this));
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    this.mockupData$ = this.widgetService.loadMockup('directCapExpenseComps').pipe(take(1));

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : this.widgetService.load('directCapExpenseComps', this.getReport()).pipe();
  }

  /**
   * Called by base class in save process. Widget should return object to be saved
   */
  async provideSaveObject(): Promise<any> {
    return this.widgetData;
  }

  public getMinimumRowIndex(): number {
    return 1;
  }

  public getMaximumRowIndex(): number {
    if (this.widgetData) {
      return this.widgetData?.rows?.length + 11;
    }
    return -1;
  }

  public moreColumnsRequestedIfOnPortraitPage(): boolean {
    if (this.widgetData.comps.length > 5) {
      return true;
    }
    else {
      return false;
  }
}
}
